import { twMerge as e } from "tailwind-merge";
import { MOBILE_FULL_WIDTH_DATA_ATTRIBUTE as i } from "../extensions/image-extension/constants/index.mjs";
const a = "group flex items-center justify-center focus-visible:outline-brand-primary rounded-lg h-3 px-[9px] py-4 [&>svg]:h-3.5 [&>svg]:w-3.5 cursor-pointer", m = (t) => e(
  "main-transition-colors",
  t ? "stroke-text-secondary" : "stroke-text-primary group-hover:stroke-brand-primary"
), l = (t) => e(
  "main-transition-colors",
  t ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
), s = (t) => e(
  "main-transition-colors",
  t ? "text-text-secondary" : "text-text-primary hover:text-brand-primary"
), p = "#000000", g = "15px", c = "#ffffff", o = "1rem", d = "8px", T = {
  marginTop: 0,
  marginBottom: 0
}, x = {
  2: {
    marginTop: "0.83em",
    marginBottom: "0.83em",
    fontSize: "1.5em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  3: {
    marginTop: "1em",
    marginBottom: "1em",
    fontSize: "1.17em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  4: {
    marginTop: "1.33em",
    marginBottom: "1.33em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold",
    fontSize: "1em"
  }
}, h = {
  marginTop: o,
  marginBottom: o,
  paddingLeft: "40px"
}, L = {
  hoverOpenDelay: 900,
  popoverClassName: "px-2 py-1 shadow-md [--anchor-gap:5px] z-[9999]"
}, _ = {
  display: "table",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: ".9em auto"
}, f = `@media (max-width: 600px) { figure[${i}="true"] { width: 100% !important; } }`, S = `@media (max-width: 600px) { img[${i}="true"] { width: 100% !important; max-width: 100% !important; } }`, E = (t) => ({
  display: "table",
  float: "right",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: t ? `${o} 0 .9em 1.5em` : "0 0 .9em 1.5em"
}), y = {
  display: "block",
  margin: "0 auto",
  minWidth: "100%",
  maxWidth: "100%"
}, b = {
  display: "table-caption",
  captionSide: "bottom",
  wordBreak: "break-word",
  textAlign: "center",
  color: "rgb(var(--text-primary))",
  backgroundColor: "rgb(var(--background-primary))",
  padding: ".6em",
  fontSize: ".75em",
  outlineOffset: "-1px"
};
export {
  y as BLOCK_IMAGE_STYLES,
  c as DEFAULT_BG_COLOR,
  p as DEFAULT_COLOR,
  g as DEFAULT_FONT_SIZE,
  d as EDITOR_PADDING,
  b as FIGCAPTION_STYLES,
  _ as FIGURE_CENTERED_STYLES,
  f as FIGURE_MOBILE_FULL_WIDTH_STYLES,
  x as HEADING_STYLES,
  S as IMAGE_MOBILE_FULL_WIDTH_STYLES,
  h as LIST_STYLES,
  T as PARAGRAPH_STYLES,
  a as TOOLBAR_BUTTON_CLASSNAMES,
  L as TOOLTIP_STYLES,
  E as getFigureRightStyles,
  s as getToolbarCaptionClassName,
  m as getToolbarIconClassName,
  l as getToolbarIconFillClassName
};
